import { z } from '@harvestiq/zod';
import { zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import {
  InsureIQPolicyTypes,
  LgmCampaignPdfColumns,
} from '@harvestiq/constants';
import { lgmSingleHeadQuoteSchema } from '@harvestiq/usda-common/lgm-helpers/lgm-single-head-quote';

export const lgmQuoteAndPdfResponseSchema = z.object({
  policyType: z.literal(InsureIQPolicyTypes.LGM),
  filename: z.string(),
  fileUrl: z.string(),
  salesEffectiveDate: zIsoDate(),
  quotes: z.record(z.string(), lgmSingleHeadQuoteSchema.array()),
  liveCattleTargetCwtPerHead: zDecimalRequired().nullable().optional(),
  feederCattleTargetCwtPerHead: zDecimalRequired().nullable().optional(),
  cornTargetBuPerHead: zDecimalRequired().nullable().optional(),
  deductibles: z.array(z.number().int().min(0).max(150)).optional(),
  quoteColumns: z.array(z.nativeEnum(LgmCampaignPdfColumns)).optional(),
  isPre2026BeginningFarmerRancher: z.boolean().optional(),
  isVeteranFarmerRancher: z.boolean().optional(),
  beginningFarmerRancherCropYearCount: z.number().int().nullable().optional(),
});

export type LgmQuoteAndPdfResponse = z.infer<
  typeof lgmQuoteAndPdfResponseSchema
>;

export const lgmQuoteTemplateDataSchema = lgmQuoteAndPdfResponseSchema.extend({
  message: z.string().optional(),
  unsubscribeURL: z.string().url().optional(),
  campaignId: z.string().uuid().optional(),
});

export type LgmQuoteTemplateData = z.infer<typeof lgmQuoteTemplateDataSchema>;
